<template>
  <li
    class="nav-item nav-dropdown"
    :class="{
      open: isOpen,
      'nav-dropdown-active': hasActiveChild,
      'nav-dropdown-has-icon': hasIcon,
      'nav-dropdown-no-icon': !hasIcon,
    }"
  >
    <button
      type="button"
      class="nav-link nav-dropdown-toggle"
      :aria-expanded="String(isOpen)"
      aria-haspopup="true"
      @click="toggleDropdown"
    >
      <i v-if="hasIcon" :class="classIcon" class="dropdown-nav-icon"></i>
      <span class="dropdown-nav-label">{{ displayLabel }}</span>
      <img
        class="dropdown-chevron"
        :src="dropdownIndicatorSrc"
        alt=""
        aria-hidden="true"
      />
    </button>
    <ul class="nav-dropdown-items nav-dropdown-bg">
      <slot></slot>
    </ul>
  </li>
</template>

<script>
export default {
  data() {
    return {
      hasActiveChild: false,
      isOpen: false,
    };
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    displayName: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  computed: {
    classIcon() {
      return ["nav-icon", this.icon];
    },
    displayLabel() {
      return this.displayName || this.name;
    },
    dropdownIndicatorSrc() {
      return `${process.env.BASE_URL}img/png/icon-left.png`;
    },
    hasIcon() {
      return Boolean(this.icon && this.icon.trim());
    },
  },
  mounted() {
    this.syncOpenStateFromRoute();
  },
  watch: {
    $route() {
      this.syncOpenStateFromRoute();
    },
  },
  methods: {
    toggleDropdown(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isOpen = !this.isOpen;
    },
    syncOpenStateFromRoute() {
      this.$nextTick(() => {
        if (!this.$el) {
          return;
        }

        const activeChild = this.$el.querySelector(
          ".nav-dropdown-items .router-link-exact-active, .nav-dropdown-items .router-link-active, .nav-dropdown-items .active"
        );

        this.hasActiveChild = Boolean(activeChild);

        if (activeChild) {
          this.isOpen = true;
        }
      });
    },
  },
};
</script>

<style scoped lang="css">
.nav-dropdown {
  overflow-anchor: none;
}

.nav-dropdown-toggle {
  -webkit-appearance: none;
  appearance: none;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  min-height: 42px;
  padding: 0.56rem 2rem 0.56rem 0.95rem;
  border: 0 !important;
  border-radius: var(--radius-sm);
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
  box-sizing: border-box;
}

.nav-dropdown-toggle::before {
  display: none !important;
  content: none !important;
}

.nav-dropdown-toggle:focus,
.nav-dropdown-toggle:focus-visible {
  outline: none;
  box-shadow: none;
  border-color: transparent !important;
}

.nav-dropdown-active > .nav-dropdown-toggle {
  background: transparent !important;
  color: rgba(255, 255, 255, 0.88) !important;
  border-color: transparent !important;
  box-shadow: none;
}

.dropdown-nav-icon {
  width: 20px;
  min-width: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  flex-shrink: 0;
}

.dropdown-nav-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 0.15rem;
}

.dropdown-chevron {
  position: absolute;
  top: 50%;
  right: 0.95rem;
  width: 8px;
  height: 12px;
  object-fit: contain;
  transform: translateY(-50%) rotate(180deg);
  opacity: 0.86;
  transition:
    transform 0.18s ease,
    opacity 0.18s ease;
  flex-shrink: 0;
  pointer-events: none;
}

.nav-dropdown.open > .nav-dropdown-toggle .dropdown-chevron {
  transform: translateY(-50%) rotate(270deg);
  opacity: 1;
}

.nav-dropdown-bg {
  margin: 0.08rem 0 0.18rem 0;
  padding: 0;
  background: transparent;
  border-left: none;
  border-radius: 0;
  list-style: none;
}

.nav-dropdown-items {
  display: none;
  max-height: none !important;
  margin: 0;
  padding-left: 0;
  list-style: none;
  overflow: visible;
  transition: none !important;
}

.nav-dropdown.open > .nav-dropdown-items {
  display: block;
}

.nav-dropdown-items > .nav-item {
  list-style: none;
}

</style>
<style lang="css">
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .nav-dropdown-toggle {
    justify-content: flex-start !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    gap: 0 !important;
  }

  .sidebar-minimized .sidebar .dropdown-nav-label,
  .sidebar-minimized .sidebar .dropdown-chevron {
    display: none !important;
  }

  .sidebar-minimized .sidebar .dropdown-nav-icon {
    width: 50px;
    min-width: 50px;
    justify-content: center;
    margin: 0 !important;
  }

  .sidebar-minimized .sidebar .nav-dropdown:hover > .nav-dropdown-toggle .dropdown-nav-label,
  .sidebar-minimized .sidebar .nav-dropdown:focus-within > .nav-dropdown-toggle .dropdown-nav-label,
  .sidebar-minimized .sidebar .nav-dropdown.open > .nav-dropdown-toggle .dropdown-nav-label {
    display: block !important;
  }

  .sidebar-minimized .sidebar .nav-dropdown:hover > .nav-dropdown-toggle .dropdown-nav-label,
  .sidebar-minimized .sidebar .nav-dropdown:focus-within > .nav-dropdown-toggle .dropdown-nav-label,
  .sidebar-minimized .sidebar .nav-dropdown.open > .nav-dropdown-toggle .dropdown-nav-label {
    padding-right: 2rem;
  }
}
</style>
